var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWaveSawtooth = function SvgIconWaveSawtooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.488 5.127A1 1 0 0 1 13 6v10.21l8.226-5.062a1 1 0 0 1 1.048 1.704l-9.75 6A1 1 0 0 1 11 18V7.79l-8.226 5.062a1 1 0 0 1-1.048-1.704l9.75-6a1 1 0 0 1 1.012-.021",
    clipRule: "evenodd"
  })));
};
export default SvgIconWaveSawtooth;